"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _tinymce = _interopRequireDefault(require("tinymce"));

var _FontSelect = _interopRequireDefault(require("rich-text-lib/components/formatting/FontSelect"));

var _usageTracking = require("../../constants/usageTracking");

var _usageTracking2 = require("../../utils/usageTracking");

var _formatting = require("../../utils/formatting");

var _getComputedStyle = require("../../utils/getComputedStyle");

var TinyMceFontSelect =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TinyMceFontSelect, _Component);

  function TinyMceFontSelect(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TinyMceFontSelect);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TinyMceFontSelect).call(this, props));

    _this.getFonts = function () {
      var _this$props = _this.props,
          fonts = _this$props.fonts,
          webfonts = _this$props.webfonts;
      return fonts.concat(webfonts);
    };

    _this.handleNodeChange = function (event) {
      var editor = _this.props.editor;
      var computedStyle = (0, _getComputedStyle.maybeGetComputedStyle)(editor.getWin(), event.element);

      if (!computedStyle) {
        return;
      }

      var fontFamily = (0, _formatting.normalizeFontStack)(computedStyle['font-family']);

      var matched = _this.getFonts().find(function (item) {
        return (0, _formatting.normalizeFontStack)(item.value) === fontFamily;
      });

      if (matched) {
        _this.setState({
          value: matched.value
        });
      } else {
        _this.setState({
          value: null
        });
      }
    };

    _this.handleChangeFont = function (event) {
      var editor = _this.props.editor;
      var value = event.target.value;
      editor.execCommand('hsfontselect', false, {
        value: value
      });
      (0, _usageTracking2.trackInteraction)(editor, 'tinymceFormatting', _usageTracking.CHANGE_FONT, {
        method: 'button',
        value: value
      });
    };

    _this.state = {
      value: null
    };
    return _this;
  }

  (0, _createClass2.default)(TinyMceFontSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var editor = this.props.editor;
      editor.on('NodeChange', this.handleNodeChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var editor = this.props.editor;
      editor.off('NodeChange', this.handleNodeChange);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          fonts = _this$props2.fonts,
          webfonts = _this$props2.webfonts;
      var value = this.state.value;
      return _react.default.createElement(_FontSelect.default, {
        dropdownClassName: "mce-hubspot-control",
        use: "on-dark",
        fonts: fonts,
        webfonts: webfonts,
        value: value,
        onChange: this.handleChangeFont
      });
    }
  }]);
  return TinyMceFontSelect;
}(_react.Component);

exports.default = TinyMceFontSelect;
TinyMceFontSelect.propTypes = {
  editor: _react.PropTypes.instanceOf(_tinymce.default.Editor),
  fonts: _react.PropTypes.array.isRequired,
  webfonts: _react.PropTypes.array
};
TinyMceFontSelect.defaultProps = {
  webfonts: []
};
module.exports = exports.default;